// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";

// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from "./AuthConfig";

// const msalInstance = new PublicClientApplication(msalConfig);

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <MsalProvider instance={msalInstance}>
//     <App />
//   </MsalProvider>
// );


// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";

// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from "./AuthConfig";

// const msalInstance = new PublicClientApplication(msalConfig);

// // 🔥 HANDLE REDIRECT RESULT HERE
// msalInstance.handleRedirectPromise().then((result) => {
//   if (result) {
//     localStorage.setItem("access_token", result.accessToken);
//     localStorage.setItem("user_email", result.account.username);

//     // Force React Admin to load dashboard
//     window.location.replace("/admin");
//   }
// });

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <MsalProvider instance={msalInstance}>
//     <App />
//   </MsalProvider>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./AuthConfig";

const msalInstance = new PublicClientApplication(msalConfig);

async function bootstrap() {
  // 🔑 REQUIRED FOR MSAL v4
  await msalInstance.initialize();

  // 🔁 Handle redirect AFTER initialize
  const result = await msalInstance.handleRedirectPromise();

  if (result) {
    localStorage.setItem("access_token", result.accessToken);
    localStorage.setItem("user_email", result.account.username);

    // Ensure React-Admin loads dashboard
    window.location.replace("/admin");
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
}

// 🚀 Start app properly
bootstrap();
